import styled from 'styled-components'

export const ScorecardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`

export const TableWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
`

export const TableCell = styled.td`
  padding: 5px;
  border-bottom: solid 1px #e4e4e4;
  text-align: center;
`

export const TitleTableCell = styled(TableCell)`
  font-weight: 900;
`

export const RatedTableCell = styled(TableCell)`
  background-color: #8b8b8b;
  color: #fff;
  padding: 5px;
  border-bottom: solid 1px #e4e4e4;
  border-left: solid 2px #000;
  border-right: solid 2px #000;
  min-width: 40px;
`

export const FixedTableCell = styled(TableCell)`
  background-color: #e4e4e4;
  padding: 5px;
  border-bottom: solid 1px #e4e4e4;
  border-right: solid 1px #e4e4e4;
  min-width: 40px;
`

export const ScorecardTableCell = styled(TableCell)`
  background-color: #e4e4e4;
  padding: 5px;
  border-bottom: solid 1px #e4e4e4;
  border-left: solid 1px #e4e4e4;
  border-right: solid 1px #e4e4e4;
  min-width: 40px;
`

export const LengthTitle = styled.div`
  text-orientation: upright;
  rotate: -85deg;
  transform-origin: left center;
  translate: 15px 5px;
  white-space: nowrap;
`
